<template>
  <div class="kpi-cards">
    <div
      v-for="(item, index) in kpiList"
      :key="index"
      class="kpi-card"
      :style="{ '--bar-color': barColors[index % barColors.length] }"
    >
      <div class="kpi-label">{{ item.label }}</div>
      <div class="kpi-value-row">
        <span class="kpi-value">{{ item.displayValue }}</span>
        <span class="kpi-unit">{{ item.unit }}</span>
      </div>
      <div class="kpi-change" :class="item.change >= 0 ? 'up' : 'down'">
        <span class="arrow">{{ item.change >= 0 ? '▲' : '▼' }}</span>
        <span>{{ Math.abs(item.change) }}%</span>
      </div>
      <!-- 底部进度条 -->
      <div class="kpi-progress-bar">
        <div class="kpi-progress-fill" :style="{ width: item.progress + '%', background: barColors[index % barColors.length] }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { kpiData } from '../mock/data'

export default {
  name: 'KpiCards',
  data() {
    return {
      /* 左侧竖条和进度条颜色循环 */
      barColors: ['#00D4FF', '#00FF88', '#FF6B35', '#A855F7', '#F59E0B', '#EC4899'],
      kpiList: []
    }
  },
  mounted() {
    this.buildKpiList()
  },
  methods: {
    formatNumber(num) {
      if (num >= 10000) {
        return (num / 10000).toFixed(1)
      }
      return num.toLocaleString()
    },
    buildKpiList() {
      this.kpiList = [
        {
          label: '全平台GMV',
          displayValue: this.formatNumber(kpiData.gmv),
          unit: '万元',
          change: kpiData.gmvChange,
          progress: 75
        },
        {
          label: '全平台订单量',
          displayValue: kpiData.orderCount.toLocaleString(),
          unit: '单',
          change: 8.3,
          progress: 85
        },
        {
          label: '在线SKU总数',
          displayValue: kpiData.skuCount.toLocaleString(),
          unit: '个',
          change: 2.1,
          progress: 60
        },
        {
          label: '平均客单价',
          displayValue: kpiData.avgPrice.toFixed(1),
          unit: '元',
          change: kpiData.avgPriceChange,
          progress: 55
        },
        {
          label: '全平台转化率',
          displayValue: kpiData.conversionRate.toFixed(2),
          unit: '%',
          change: kpiData.conversionChange,
          progress: 40
        },
        {
          label: '目标完成率',
          displayValue: kpiData.orderTarget,
          unit: '%',
          change: 5.2,
          progress: 85
        }
      ]
    }
  }
}
</script>

<style scoped>
.kpi-cards {
  height: 90px;
  display: flex;
  gap: 12px;
  padding: 0 10px;
}

.kpi-card {
  flex: 1;
  background: rgba(6, 30, 60, 0.85);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 4px;
  padding: 12px 16px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

/* 顶部渐变线 */
.kpi-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00D4FF, transparent);
}

/* 左侧彩色竖条 */
.kpi-card::after {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 2px;
  background: var(--bar-color);
}

/* hover效果 */
.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 212, 255, 0.15);
}

.kpi-label {
  font-size: 12px;
  color: #B0D4F1;
  margin-bottom: 4px;
}

.kpi-value-row {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.kpi-value {
  font-size: 24px;
  font-weight: bold;
  font-family: 'DIN', 'Courier New', monospace;
  color: #00D4FF;
  line-height: 1.2;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.kpi-unit {
  font-size: 12px;
  color: #B0D4F1;
}

.kpi-change {
  font-size: 12px;
  margin-top: 2px;
  font-family: 'DIN', 'Courier New', monospace;
}

.kpi-change.up {
  color: #00FF88;
}

.kpi-change.down {
  color: #FF6B35;
}

.arrow {
  margin-right: 2px;
}

/* 底部进度条 */
.kpi-progress-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: rgba(0, 212, 255, 0.1);
}

.kpi-progress-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.6s ease;
}
</style>
